export default __webpack_public_path__ + "static/media/banner_one.33c50a9a.jpg";